// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    getSelectedCategoryPath,
    getSelectedProductPath,
} from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCatalogPageStateByPath } from "@insite/client-framework/Store/Data/CatalogPages/CatalogPagesSelectors";
import { getCategoryState } from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getProductStateByPath } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import { getProductListDataView } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import { ActiveState, SeoAppProps } from "@tps/App/Widgets/SearchEngineOptimization/Type";

const getProductsActiveState = ({ state, currentPage, payload }: SeoAppProps): ActiveState => {
    const isProductsListingPage = currentPage.type === "CategoryDetailsPage" || currentPage.type === "ProductListPage";
    const isProductDetailsPage = currentPage.type === "ProductDetailsPage";

    payload.products = [];

    if (isProductsListingPage) {
        payload.products = getProductListDataView(state)?.value;

        const location = getLocation(state);
        const categoryPath =
            getSelectedCategoryPath(state) ||
            (location.pathname.toLowerCase().startsWith("/content/") ? "" : location.pathname);

        const catalogPageState = getCatalogPageStateByPath(state, categoryPath)?.value;

        payload.category = getCategoryState(
            state,
            catalogPageState?.categoryIdWithBrandId ?? catalogPageState?.categoryId,
        )?.value;

        payload.brandName = catalogPageState?.properties?.brandName;
    }

    if (isProductDetailsPage) {
        const location = getLocation(state);
        const productPath =
            getSelectedProductPath(state) ||
            (location.pathname.toLowerCase().startsWith("/content/") ? "" : location.pathname);

        const productState = getProductStateByPath(state, productPath)?.value;

        payload.products = productState ? [productState] : [];
    }

    return (isProductsListingPage || isProductDetailsPage) && !!payload?.products?.length;
};

export default getProductsActiveState;
